import { Accordion, Card, Container, Row, Col, Button } from "react-bootstrap";
import LatpayFooter from "../layout/footer";
import LatpayCopyright from "../layout/copyright";
import LatpayHeader from "../layout/header";

const Home = () => {
    return ( 
        <div style={{ paddingTop: '76px' }} id="home">
            <LatpayHeader />
            
            {/* 1. SPLIT-SCREEN HERO SECTION */}
            <section className="bg-light py-5 position-relative overflow-hidden">
                <Container className="py-5">
                    <Row className="align-items-center gy-5">
                        <Col lg={6} className="text-center text-lg-start z-index-1">
                            <h1 className="display-4 fw-bold text-dark mb-4">
                                The unified payment platform for global growth.
                            </h1>
                            <p className="lead text-secondary mb-5 pe-lg-5">
                                Accept payments anywhere, automate your financial operations, and scale your business with Latpay’s secure, developer-friendly infrastructure.
                            </p>
                            <div className="d-flex flex-column flex-sm-row gap-3 justify-content-center justify-content-lg-start">
                                <Button variant="primary" style={{backgroundColor : "#253370"}} size="lg" className="px-4 py-3 fw-semibold shadow-sm" href="https://latpay.com/contact/">
                                    Start Processing Today
                                </Button>
                                <Button variant="outline-dark" size="lg" className="px-4 py-3 fw-semibold" href="#features">
                                    Explore Features
                                </Button>
                            </div>
                        </Col>
                        <Col lg={6} className="text-center">
                            {/* Suggestion: A floating UI mockup of a payment dashboard or mobile app */}
                            <img 
                                src="images/hero-dashboard-mockup.svg" 
                                alt="Latpay Dashboard" 
                                className="img-fluid rounded shadow-lg"
                                style={{ transform: 'perspective(1000px) rotateY(-10deg)', transition: 'transform 0.3s ease' }}
                            />
                        </Col>
                    </Row>
                </Container>
            </section>

            {/* 2. TRUST BANNER (LOGOS) */}
            <section className="py-4 border-bottom border-light">
                <Container>
                    <p className="text-center text-muted small fw-bold text-uppercase tracking-wider mb-4">
                        Trusted by innovative businesses worldwide
                    </p>
                    <Row className="justify-content-center align-items-center opacity-50 gx-5 gy-3">
                        {/* Replace these with actual client/partner logos */}
                        <Col xs={4} md={2} className="text-center"><h5 className="mb-0 text-muted">Visa</h5></Col>
                        <Col xs={4} md={2} className="text-center"><h5 className="mb-0 text-muted">Mastercard</h5></Col>
                        <Col xs={4} md={2} className="text-center"><h5 className="mb-0 text-muted">Amex</h5></Col>
                        <Col xs={4} md={2} className="text-center"><h5 className="mb-0 text-muted">Shopify</h5></Col>
                        <Col xs={4} md={2} className="text-center"><h5 className="mb-0 text-muted">WooCommerce</h5></Col>
                    </Row>
                </Container>
            </section>

            {/* 3. ZIG-ZAG FEATURES SECTION */}
            <section id="features" className="py-5 mt-5">
                <Container>
                    {/* Feature 1: Text Left, Image Right */}
                    <Row className="align-items-center mb-5 pb-5">
                        <Col md={6} className="pe-lg-5 mb-4 mb-md-0">
                            <div className="text-primary fw-bold text-uppercase mb-2 small">Omnichannel Payments</div>
                            <h2 className="fw-bold mb-4">Accept payments online, in-app, or in-store.</h2>
                            <p className="text-muted fs-5 mb-4">
                                Provide your customers with a frictionless checkout experience, no matter how they choose to buy. Our APIs support major credit cards, digital wallets, and local payment methods globally.
                            </p>
                            <ul className="list-unstyled text-muted">
                                <li className="mb-2">✓ 99.99% Uptime API Reliability</li>
                                <li className="mb-2">✓ Seamless Checkout Integration</li>
                                <li className="mb-2">✓ Support for 135+ Currencies</li>
                            </ul>
                        </Col>
                        <Col md={6}>
                            <img src="images/feature-omnichannel.jpg" alt="Omnichannel Checkout" className="img-fluid rounded shadow" />
                        </Col>
                    </Row>

                    {/* Feature 2: Image Left, Text Right */}
                    <Row className="align-items-center flex-column-reverse flex-md-row py-5">
                        <Col md={6}>
                            <img src="images/feature-security.jpg" alt="Fraud Prevention" className="img-fluid rounded shadow" />
                        </Col>
                        <Col md={6} className="ps-lg-5 mb-4 mb-md-0">
                            <div className="text-primary fw-bold text-uppercase mb-2 small">Risk Management</div>
                            <h2 className="fw-bold mb-4">Bank-level security and fraud prevention.</h2>
                            <p className="text-muted fs-5 mb-4">
                                Protect your revenue with our advanced machine learning algorithms. Latpay detects and blocks fraudulent transactions in real-time before they impact your business.
                            </p>
                            <ul className="list-unstyled text-muted">
                                <li className="mb-2">✓ PCI-DSS Level 1 Compliant</li>
                                <li className="mb-2">✓ 3D Secure 2.0 Authentication</li>
                                <li className="mb-2">✓ Dynamic Risk Scoring</li>
                            </ul>
                        </Col>
                    </Row>
                </Container>
            </section>

            {/* 4. FINAL CALL TO ACTION */}
            <section className="bg-primary back text-white py-5 text-center" id="solutions">
                <Container className="py-5">
                    <Row className="justify-content-center">
                        <Col md={8}>
                            <h2 className="display-6 fw-bold mb-4">Ready to upgrade your payment experience?</h2>
                            <p className="fs-5 mb-5 opacity-75">
                                Join thousands of businesses that trust Latpay to power their financial infrastructure.
                            </p>
                            <Button variant="light" size="lg" className="text-primary fw-bold px-5 py-3" href="https://latpay.com/contact/">
                                Contact Sales
                            </Button>
                        </Col>
                    </Row>
                </Container>
            </section>

            {/* FEATURES SECTION */}
            {/* <section id="features" className="py-5 bg-light">
                <Container className="py-5">
                    <div className="text-center mb-5">
                        <h2 className="fw-bold">Why Choose Latpay?</h2>
                        <p className="text-muted fs-5">Everything you need to process payments efficiently and securely.</p>
                    </div>
                    <Row className="g-4 text-center">
                        <Col md={4}>
                            <Card className="h-100 border-0 shadow-sm p-4">
                                <Card.Body>
                                    <img src="images/feature-secure.png" alt="Secure" height="64" className="mb-3"/>
                                    <Card.Title>Advanced Fraud Protection</Card.Title>
                                    <Card.Text>
                                        Our AI-driven risk management system identifies and blocks fraudulent transactions before they happen.
                                    </Card.Text>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col md={4}>
                            <Card className="h-100 border-0 shadow-sm p-4">
                                <Card.Body>
                                    <img src="images/feature-global.png" alt="Global" height="64" className="mb-3"/>
                                    <Card.Title>Multi-Currency Support</Card.Title>
                                    <Card.Text>
                                        Settle in multiple currencies and expand your business globally without worrying about conversion headaches.
                                    </Card.Text>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col md={4}>
                            <Card className="h-100 border-0 shadow-sm p-4">
                                <Card.Body>
                                    <img src="images/feature-analytics.png" alt="Analytics" height="64" className="mb-3"/>
                                    <Card.Title>Real-Time Analytics</Card.Title>
                                    <Card.Text>
                                        Monitor your cash flow, track transaction success rates, and gain valuable business insights from our dashboard.
                                    </Card.Text>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </section> */}

            <section id="faq" className="py-5">
                <Container className="py-5">
                    <Row className="justify-content-center">
                        <Col md={8}>
                            <div className="text-center mb-5">
                                <h2 className="fw-bold">Frequently Asked Questions</h2>
                                <p className="text-muted">Common questions about getting started with Latpay.</p>
                            </div>
                            <Accordion defaultActiveKey="0">
                                <Accordion.Item eventKey="0">
                                    <Accordion.Header>How long does it take to integrate Latpay?</Accordion.Header>
                                    <Accordion.Body>
                                        Integration times vary depending on your platform, but our comprehensive API documentation and SDKs allow most developers to get up and running in less than 24 hours.
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="1">
                                    <Accordion.Header>What are your transaction fees?</Accordion.Header>
                                    <Accordion.Body>
                                        We offer competitive, transparent pricing tailored to your business volume. There are no hidden setup fees. Please contact our sales team for a custom quote based on your monthly processing volume.
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="2">
                                    <Accordion.Header>Is Latpay PCI compliant?</Accordion.Header>
                                    <Accordion.Body>
                                        Yes, Latpay is fully PCI-DSS Level 1 compliant, ensuring that your customers' payment data is handled with the highest level of security available in the industry.
                                    </Accordion.Body>
                                </Accordion.Item>
                            </Accordion>
                        </Col>
                    </Row>
                </Container>
            </section>

            <LatpayFooter/>
            <LatpayCopyright/>
        </div>
    );
}
 
export default Home;